import DateInputRange from './DateInputRange'
import DropdownRange, { OptionsState } from './DropdownRange'
import NumberInputRange from './NumberInputRange'

export interface BaseInputFieldProps {
    label?: string
    subtext?: string | React.ReactNode
    isRequired?: boolean
    isCommentable?: boolean
    isCommented?: boolean
    size?: 'm' | 's'
    firstRangeTitle?: string
    firstRangeName?: string
    firstRangePlaceholder?: string
    firstRangeIdentifier?: string
    firstRangeId?: string
    secondRangeTitle?: string
    secondRangeName?: string
    secondRangePlaceholder?: string
    secondRangeIdentifier?: string
    secondRangeId?: string
    width?: string
    inputWidth?: string
    isVertical?: boolean
    isDisabled?: boolean
    isReadOnly?: boolean
    errorMessage?: string
    onClose?: () => void
    className?: string
    identifier?: string
}

const RangeInput = {
    Date: DateInputRange,
    Dropdown: DropdownRange,
    Number: NumberInputRange,
}
export default RangeInput
export type { OptionsState }
